import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReportActions = ({ onExportPDF, onShareReport }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="Zap" size={20} color="var(--color-accent-foreground)" />
        </div>
        <h2 className="text-xl md:text-2xl font-semibold text-foreground">Tindakan Selanjutnya</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <Button
          variant="default"
          iconName="Download"
          iconPosition="left"
          onClick={onExportPDF}
          fullWidth
        >
          Unduh Laporan PDF
        </Button>

        <Button
          variant="outline"
          iconName="Share2"
          iconPosition="left"
          onClick={onShareReport}
          fullWidth
        >
          Bagikan Laporan
        </Button>

        <Button
          variant="secondary"
          iconName="ListChecks"
          iconPosition="left"
          onClick={() => navigate('/action-plan-dashboard')}
          fullWidth
        >
          Lihat Rencana Aksi
        </Button>

        <Button
          variant="outline"
          iconName="Target"
          iconPosition="left"
          onClick={() => navigate('/decision-matrix')}
          fullWidth
        >
          Matriks Keputusan
        </Button>
      </div>

      <div className="p-4 rounded-lg bg-primary/5 border border-primary/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-sm font-semibold text-foreground mb-2">Catatan Penting</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Laporan ini berisi informasi rahasia dan hanya untuk konsumsi internal. Pastikan untuk mengamankan dokumen ini dan membagikannya hanya kepada pihak yang berwenang. Untuk pertanyaan lebih lanjut, hubungi tim analisis di analysis@isuka.co.id
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportActions;